module.exports = __webpack_public_path__ + "img/delete.d1cf9852.svg";